<div class="card-header-tab card-header">
  <div class="card-header-title full-width">
    <ng-content></ng-content>
  </div>
</div>
